import { render } from "./StandardOpeningHours.vue?vue&type=template&id=d22d5126&scoped=true&ts=true"
import script from "./StandardOpeningHours.vue?vue&type=script&lang=ts"
export * from "./StandardOpeningHours.vue?vue&type=script&lang=ts"

import "./StandardOpeningHours.vue?vue&type=style&index=0&id=d22d5126&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d22d5126"]])

export default __exports__